<template>
  <div :class="[b(), className]" :style="styleSizeName" ref="sheetContainer" >
    <Sheet
        :style="sheetStyle"
        :schema="schema"
        ref="sheet"
        :thisArg="thisArg"
        :isDataCenter="isDataCenter"
        :dataChart="dataChart"
    ></Sheet>
  </div>
</template>

<script>
import Sheet from "./sheet.vue";

export default {
  name: "sheet",
  components: {
    Sheet,
  },
  data() {
    return {
      sheetStyle: {
        width: "100%",
      },
    };
  },
  computed: {
    thisArg() {
      return this
    },
    schema() {
      return {prop: {...this.option, ...this.prop}, themeCfg: this.themeCfg};
    },
  },
  methods: {
    handlerDimParam(param) {
      if (param?.paramMap?._sheetType) {
        param.paramMap._sheetType = this.prop?.groups?.length ? "summary" : this.option.spreadSheetType;
      }
      return param
    },
    updateChart() {
      // _sheetType: props.schema.prop?.groups?.length ? "summary" : props.schema.prop.spreadSheetType,
      this.$refs["sheet"]?.handlerRes();
      if (this.option.autoHeight) {
        // 自适应高度操作父元素样式
        styleSizeName.height = "fit-content"
        sheetStyle.height = "fit-content"
        this.$el.parentNode.style.height = "fit-content"
        this.$el.parentNode.parentNode.style.height = "fit-content"
        this.$el.parentNode.parentNode.parentNode.style.height = "fit-content"
      }
    },
  },
};
</script>



